export default __webpack_public_path__ + "static/media/yodo1Logo.1475b47d.svg";